import { render, staticRenderFns } from "./postavshikam.vue?vue&type=template&id=ea2581e6&"
import script from "./postavshikam.vue?vue&type=script&lang=js&"
export * from "./postavshikam.vue?vue&type=script&lang=js&"
import style0 from "./postavshikam.vue?vue&type=style&index=0&id=ea2581e6&prod&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports